<template>
  <div>     
    <transition name="fade">
      <router-view></router-view>   
		</transition>  
    <!-- 底部导航 -->  
    <nav-tabbar ></nav-tabbar>
    <!-- 底部导航 end--> 
  </div>
</template> 
<script>
import NavTabbar from '@/components/NavTabbar.vue' 

export default {
  name: "Act8Index",
  components: {
    'nav-tabbar': NavTabbar,    
  },
  data() {
    return {   
        
    };
  },
  mounted() {

  },
  created() {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/act/8/Index.vue